module.exports = __webpack_public_path__ + "static/media/sound_error.fac8e2e8.mp3";